import React from 'react';
import PropTypes from 'prop-types';

import { kebabCase } from 'lodash';
import { camelize } from 'inflected';
import displayName from 'component-lib/displayName';

import styles from './RadioButtons.scss';

export default function RadioButtonGenerator(type) {
    function RadioButton(props) {
        const {
            id: radioId,
            onSelect,
            selectedId,
            data,
        } = props;

        return (
            <div
                data-form-type="radio"
                data-radio={kebabCase(radioId)}
            >
                {
                    data.map(({ id, value }) => (
                        <span
                            role="radio"
                            aria-checked={id === selectedId}
                            tabIndex="-1"
                            key={id}
                            data-radio-item={`radio-${kebabCase(id)}`}
                            data-action={`select-${kebabCase(id)}`}
                            className={styles[`radio-button-${type}`]}
                            onClick={() => { onSelect(id, radioId); }}
                        >
                            <input
                                className={styles['radio-hidden']}
                                type="radio"
                                id={`radio-${kebabCase(radioId)}`}
                                name={`radio-${kebabCase(id)}`}
                                onChange={() => {}}
                                checked={id === selectedId}
                            />
                            <label
                                className={styles['radio-label']}
                                htmlFor={`radio-${kebabCase(id)}`}
                            >
                                <span className={styles['radio-button']} />
                                <span className={styles['radio-text']}>
                                    {value}
                                </span>
                            </label>
                        </span>
                    ))
                }
            </div>
        );
    }

    RadioButton.propTypes = {
        id: PropTypes.string.isRequired,
        onSelect: PropTypes.func.isRequired,
        selectedId: PropTypes.string.isRequired,
        data: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.string.isRequired,
            value: PropTypes.node.isRequired,
        }).isRequired,).isRequired,
    };

    RadioButton.displayName = displayName(`Forms/RadionButtons/${camelize(type)}RadioButton`);

    return RadioButton;
}
